import { Reducer } from 'redux';
import { FarmStateHelper } from 'State/Player/Farm/FarmStateHelper';
import { ActionType, getType } from 'typesafe-actions';
import { IGameState } from '../Game/IGameState';
import { FarmActions } from './FarmActions';

export const FarmReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof FarmActions>
): IGameState => {
    return handleAction(state, action);
};

function handleAction(state: IGameState, action: ActionType<typeof FarmActions>): IGameState {
    switch (action.type) {
        case getType(FarmActions.setSlotItemPreview):
            return FarmStateHelper.setFarmSlotItemPreview(state, action.payload.slotId, action.payload.itemId);
        case getType(FarmActions.confirmSlotItem):
            return FarmStateHelper.confirmSlotItem(state, action.payload.slotId, action.payload.itemId);
        case getType(FarmActions.cancelSlotItem):
            return FarmStateHelper.cancelSlotItem(state);
        case getType(FarmActions.setConstructionMode):
            return FarmStateHelper.setConstructionModeEnabled(state, action.payload);
        case getType(FarmActions.receiveMiniGameReward):
            return FarmStateHelper.receiveMiniGameReward(state, action.payload);
        case getType(FarmActions.purchaseFarmArea):
            return FarmStateHelper.purchaseFarmArea(state, action.payload);
        case getType(FarmActions.clearFarmAreas):
            return FarmStateHelper.updateGameState(state, FarmStateHelper.clearFarmAreas(state.playerState.farmState));
        case getType(FarmActions.setFarmCatalogueTab):
            return FarmStateHelper.setFarmCatalogueTab(state, action.payload);
        default:
            return state;
    }
}
